<template>
  <div id="home">
    <!-- <div class="top"></div> -->
    <div class="div">
      <div class="mzsm" @click="show = true">
        <img src="../assets/icon-dp.png" alt />
        <span>免责声明</span>
      </div>
      <img class="logo" src="../assets/login.png" alt />
      <div class="seach">
        <div class="time" @click="tz(2)">{{starttime?starttime+'~'+endtime:"时间范围"}}</div>
        <input
          :style="{width:(starttime?'40%':'')}"
          type="text"
          v-model="name"
          placeholder="游戏名称/单位/著作人/版号/文号"
          ref="inputseach"
          @click="tz(3)"
        />
        <div class="icons" @click="tz(3)">
          <img class="seachimg" src="../assets/icon-seach.png" alt />
        </div>
      </div>
    </div>

    <mescroll-vue
      ref="mescroll"
      :down="mescrollDown"
      :up="mescrollUp"
      @init="mescrollInit"
      class="scrollView mescroll"
    >
      <div id="boxx">
        <div
          class="box"
          v-for="(item,index) in articleList"
          :key="index"
          @click="getdetails(item.id)"
        >
          <div class="title clearfix">
            <h1>{{item.gamename}}</h1>
            <span class="bq" v-if="item.declaretype">{{item.declaretype}}</span>
            <span class="ts">{{item.remark}}</span>
          </div>
          <div class="content">
            <div class="content-box clearfix">
              <span class="left">出版单位</span>
              <span class="left">{{item.pubunitname}}</span>
            </div>
            <div class="content-box clearfix">
              <span class="left">著作权人</span>
              <span class="left">{{item.authorname}}</span>
            </div>
          </div>
          <div class="footer clearfix">
            <span class="left">{{item.piwenno}}</span>
            <span class="right">{{item.isbn}}</span>
          </div>
        </div>
      </div>
    </mescroll-vue>

    <!-- <div class="seach">
      <input type="text" v-model="seach" placeholder="请输入您要搜索的任意关键字" />
      <div class="icons" @click="init">
        <svg
          t="1590458816816"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1747"
          width="200"
          height="200"
        >
          <path
            d="M485.376 238.933333A239.388444 239.388444 0 1 0 724.764444 477.866667a239.616 239.616 0 0 0-239.388444-238.933334z m0 444.643556a204.8 204.8 0 1 1 204.8-204.8 204.8 204.8 0 0 1-204.8 203.889778z"
            p-id="1748"
          />
          <path
            d="M403.456 344.519111a155.875556 155.875556 0 0 0-75.093333 133.347556 17.066667 17.066667 0 0 0 34.133333 0 121.969778 121.969778 0 0 1 58.709333-104.675556 17.066667 17.066667 0 0 0-17.749333-28.672zM773.688889 755.939556l-78.279111-78.279112a17.066667 17.066667 0 0 0-24.120889 24.120889l78.279111 78.279111A17.066667 17.066667 0 1 0 773.688889 755.939556z"
            p-id="1749"
          />
        </svg>
      </div>
    </div>

    <div class="box" v-for="item in data" :key="item.id" @click="getdetails(item.id)">
      <div class="title clearfix">
        <h1>{{item.gamename}}</h1>
        <span class="bq">{{item.gametype}}</span>
      </div>
      <div class="content">
        <div class="content-box clearfix">
          <span class="left">出版单位</span>
          <span class="left">{{item.pubunitname}}</span>
        </div>
        <div class="content-box clearfix">
          <span class="left">著作权人</span>
          <span class="left">株式会社Bushiroad、株式会社Akats按时客家话</span>
        </div>
      </div>
      <div class="footer clearfix">
        <span class="left">{{item.piwenno}}</span>
        <span class="right">{{item.isbn}}</span>
      </div>
    </div>-->
    <div class="loading" v-if="isLoad">
      <div class="loader"></div>
    </div>
    <van-popup
      v-model="show"
      closeable
      close-icon="close"
      position="center"
      :close-on-click-overlay="false"
    >
      <div class="mzz">
        <h1>免责声明</h1>
        <div>查询结果仅供参考，请以国家新闻出版署发布文件为准。</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import Popup from "vant/lib/popup";
import "vant/lib/popup/style";
export default {
  data() {
    return {
      seach: "",
      PageNo: 1,
      PageSize: 10,
      authorname: "",
      name: "",
      pubunitname: "",
      show: false,
      saleunit: "",
      gamename: "",
      starttime: "",
      endtime: "",
      // data: [],
      Total: 0,
      isLoad: false,
      mescroll: null, // mescroll实例对象
      mescrollDown: {}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        //以下是一些常用的配置,当然不写也可以的.
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10 //每页数据条数,默认10
        },
        noMoreSize: 5, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        toTop: {
          //回到顶部按钮
          src:
            "data:image/png;base64,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", //图片路径,默认null,支持网络图
          offset: 1000 //列表滚动1000px才显示回到顶部按钮
        }, //在此我向大家推荐一个前端全栈开发交流圈：619586920 突破技术瓶颈，提升思维能力
        htmlContent:
          '<p class="downwarp-progress"></p><p class="downwarp-tip">下拉刷新 </p>', //布局内容
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          warpId: "boxx", //父布局的id (1.3.5版本支持传入dom元素)
          tip: "暂无相关数据~" //提示
        } //在此我向大家推荐一个前端全栈开发交流圈：619586920 突破技术瓶颈，提升思维能力
      },
      articleList: []
    };
  },
  components: {
    MescrollVue, // 注册mescroll组件
    vanPopup: Popup
  },
  beforeRouteLeave(to, form, next) {
    let img = document.querySelector(".mescroll-totop");
    if (img) {
      img.remove();
    }
    next();
  },
  mounted() {},
  methods: {
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    upCallback(page, mescroll) {
      let { PageNo, PageSize, seach } = this;
      let parmas = {
        name: seach,
        PageNo: page.num,
        PageSize: page.size,
        authorname: this.authorname,
        pubunitname: this.pubunitname,
        saleunit: this.saleunit,
        gamename: this.gamename,
        endtime: this.endtime,
        starttime: this.starttime
      };
      this.$http.post("api/Game/GetGameIsbnData", parmas).then(res => {
        if (res.status == 200) {
          let data = page.num == 1 ? [] : this.articleList;
          data.push(...res.data.Data.List);
          this.articleList = data;
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            mescroll.endSuccess(res.data.Data.List.length);
            this.isLoad = false;
          });
        }
      });
    },

    getdetails(id) {
      this.$router.push({
        path: "/details",
        query: {
          id: id
        }
      });
    },
    tz(type) {
      this.$router.push({
        name: "seach",
        query: {
          type: type,
          starttime: this.starttime,
          endtime: this.endtime,
          name: this.name
        }
      });
    }
  },
  created() {
    this.isLoad = true;
    this.seach = this.$route.query.name || "";
    this.name = this.$route.query.name || "";
    this.authorname = this.$route.query.authorname || "";
    this.pubunitname = this.$route.query.pubunitname || "";
    this.saleunit = this.$route.query.saleunit || "";
    this.gamename = this.$route.query.gamename || "";
    this.starttime = this.$route.query.starttime || "";
    this.endtime = this.$route.query.endtime || "";

    // this.init();
  }
};
</script>
<style lang="scss">
#home {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // overflow-y: scroll;
  background: #f5f6f5;

  .van-popup {
    border-radius: 10px;
    overflow: visible !important;
    .van-icon-close {
      top: -30px !important;
      right: 0px;
    }
  }
  .mzz {
    // height: 100px;
    padding: 20px 30px;
    width: 200px;
    // box-sizing: border-box;
    h1 {
      font-size: 15px;
      text-align: center;
    }
    div {
      margin-top: 15px;
      font-size: 15px;
    }
  }
  .loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 1);
    z-index: 9999999;
  }
  .top {
    position: fixed;
    top: 0;
    width: 100%;
    height: 4px;
    background: rgba(2, 163, 213, 1);
  }
  .mescroll {
    position: fixed;
    top: 152px;
    height: auto;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .div {
    width: 100%;
    height: 146px;
    overflow: hidden;
    background: rgba(2, 163, 213, 1);
    position: relative;
    .mzsm {
      position: absolute;
      top: 8px;
      right: 8px;
      img {
        // display: block;
        width: 12px;
        // vertical-align: middle;
        float: left;
        margin-top: 3px;
        margin-right: 1px;
      }
      span {
        float: left;
        // display: block;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
    .logo {
      width: 305px;
      display: block;
      margin: 0 auto;
      margin-top: 30px;
    }
  }
  .seach {
    width: 351px;
    height: 42px;
    background: rgba(255, 255, 255, 1);
    border-radius: 21px;
    margin: 0 auto;
    margin-top: 26px;
    overflow: hidden;
    position: relative;
    .time {
      float: left;
      height: 42px;
      //   width: 180px;
      max-width: 180px;
      min-width: 80px;
      line-height: 42px;
      margin-left: 12px;
      font-size: 15px;
      padding-right: 15px;
      box-sizing: border-box;
      font-weight: 400;
      color: rgba(2, 163, 213, 1);
      position: relative;
      &:before {
        　　content: "";
        　　width: 0;
        　　height: 0;
        　　position: absolute;
        　　top: 17px;
        // transform: translateY(-50%);
        // 　　left: 0px;
        right: 4px;
        　　border-top: solid 5px transparent;
        　　border-left: solid 5px rgba(2, 163, 213, 1);
        　　border-bottom: solid 5px transparent;
        transform: rotate(90deg);
      }
    }

    .icons {
      width: 50px;
      //   float: right;
      height: 42px;
      position: absolute;
      right: 0px;
      top: 0;

      .seachimg {
        width: 16px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    input {
      //   width: 220px;
      min-width: 100px;
      height: 100%;
      padding: 0 16px;
      float: left;
      box-sizing: border-box;
      font-size: 15px;
      width: 65%;
      font-weight: 400;
      // color: rgba(204, 204, 204, 1);
      box-sizing: border-box;
    }
    input:after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
    input[type="text"]:focus {
      outline: none; // 如何把蓝色去掉？
      border: none; // 如何改成别的颜色？
    }
    input::-webkit-input-placeholder {
      /* WebKit browsers 适配谷歌 */
      font-size: 12px;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
    }
    input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 适配火狐 */
      font-size: 12px;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
    }
    input::-moz-placeholder {
      /* Mozilla Firefox 19+ 适配火狐 */
      font-size: 12px;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10+  适配ie*/
      font-size: 12px;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
    }
  }
  // .seach::after {
  //   content: "";
  //   display: block;
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   right: 0;
  //   bottom: 0;
  // }
  .box {
    width: 351px;
    // height: 148px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 16px;
    padding: 12px 16px;
    box-sizing: border-box;
    .title {
      h1 {
        font-size: 18px;

        font-weight: 700;
        color: rgba(0, 0, 0, 1);
        line-height: 27px;
        float: left;
        margin-right: 6px;
      }
      .bq {
        float: left;
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        align-content: center;

        height: 18px;
        padding: 0 8px;
        box-sizing: border-box;
        background: rgba(2, 163, 213, 0.1);
        border-radius: 2px;
        margin-top: 4.5px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(2, 163, 213, 1);
        vertical-align: middle;
        &::before {
          vertical-align: middle;
          display: inline-block;
          content: "";
          width: 10px;
          margin-right: 2px;
          height: 10px;
          background-image: url("../assets/icon-lb.png");
          background-repeat: no-repeat;
          background-size: 10px 10px;
          background-position: center;
        }
      }
      .ts{
        float: right;
        display: inline-block;
        margin-top:4.5px;
        color:red;
      }
    }
    .content {
      padding: 10px 0;
      border-bottom: 1px solid #eeeeee;

      .content-box {
        margin-top: 6px;
        span {
          display: inline-block;
          font-size: 14px;

          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 21px;
        }
        span:nth-child(2) {
          margin-left: 12px;
          width: 77%;
          color: #000000;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .footer {
      margin-top: 10px;
      span {
        display: inline-block;
        line-height: 20px;
        font-size: 13px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
  // .box:hover {
  //   background-color: #eee;
  // }
}
</style>
